import { Component, Input, } from '@angular/core';
// import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-loader',
    // imports: [MatProgressSpinnerModule],
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.scss',
    standalone: false
})
export class LoaderComponent {

  @Input() loading: boolean = false;
  @Input() buttonLoader: boolean = false;

}
